"use strict";

export const TapNativeProperties = new Set(['minPointers', 'numberOfTaps', 'maxDeltaX', 'maxDeltaY', 'maxDurationMs', 'maxDelayMs', 'maxDist']);
//# sourceMappingURL=TapTypes.js.map